import React from "react";
import styled from "styled-components";

const Container = styled.div`
  position: relative;
  padding-top: ${(props) => props.aspectRatio}%;
  background-color: grey;
`;
const Inner = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.5s;
`;

export default function Placeholder({
  aspectRatio = 100,
  isLoaded = true,
  children,
  className,
}) {
  return (
    <Container aspectRatio={aspectRatio} className={className}>
      <Inner style={{ opacity: isLoaded ? 1 : 0 }}>{children}</Inner>
    </Container>
  );
}
